import { Injectable } from "@angular/core";
import { DwdmDiagramAbstractConverterIntermediates } from "../../diagram/converter/dwdm-diagram-abstract-converter-intermediates";
import { IntermediatesConverterData, IntermediateElementIdentifier } from "../../diagram/converter/dwdm-diagram-converter.models";
import { DwdmDiagramWizardConverterAmplifiersService } from "./dwdm-diagram-wizard-converter-amplifiers.service";
import { DwdmDiagramWizardConverterOscsService } from "./dwdm-diagram-wizard-converter-oscs.service";

/**
 * Implementação da @see DwdmDiagramAbstractConverterIntermediates para a wizard de criação de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterIntermediatesService extends DwdmDiagramAbstractConverterIntermediates {

    constructor(private readonly amplifiersConverterService: DwdmDiagramWizardConverterAmplifiersService,
            private readonly oscsConverterService: DwdmDiagramWizardConverterOscsService) {
        super();
    }

    public convert(intermediatesData: IntermediatesConverterData): IntermediateElementIdentifier[] {
        return this.convertData(intermediatesData, {
            amplifiers: (data) => this.amplifiersConverterService.convert(data),
            oscs: (data) => this.oscsConverterService.convertForIntermediate(data)
        });
    }
}
